import request from '@/utils/request'

// 取得 Authorization
export function fetchNewsList(data) {
  return request({
    url: '/News/list',
    method: 'post',
    data: {
      Data: data
    }
  })
}

